import { useCallback } from 'react';
import JSB from '@bridge/sharee';
import { HttpMethod } from './fetch';
import { useFetch } from './use-fetch';

export type UploadImageProps = {
  /** web端上传参 */
  image?: File;
  /** 端内使用base64 */
  base64Image?: string;
  isInApp: boolean;
};

/**
 * 上传图片获取cdn的url
 * 返回url
 */
export const useFetchUploadImage = () => {
  const fetch = useFetch();

  return useCallback(async (props: UploadImageProps) => {
    const uploadUrl = `${location.protocol}//${location.host}/api/200/image/upload`;
    const { image, isInApp, base64Image } = props;
    let res;
    // 端上调用JSB上传
    if (isInApp && base64Image) {
      res = await JSB.app.uploadImage({
        base64: base64Image,
        url: uploadUrl,
      });
      if (res.message === 'success') {
        return {
          url: res.data.url_list[0].url,
          uri: res.data.uri,
        };
      }
    } else {
      if (image) {
        res = await fetch('/api/200/image/upload', {
          method: HttpMethod.post,
          isFormData: true,
          params: {
            image,
          },
        }).catch((err) => ({
          message: `error`,
          err,
        }));
      }
    }

    if (res.message === 'success') {
      return {
        url: res.data.url_list[0].url || '',
        uri: res.data.uri || '',
      };
    }

    throw new Error('image upload error');
  }, []);
};
